type AlarmActionStatus = 'failure' | 'noop' | 'success';

export type AlarmActionOutcome =
	| {
			outcome: 'failure';
			reason: 'native_id_collision' | 'native_id_conflict' | 'notification_refresh_failed';
	  }
	| {
			outcome: 'noop';
			reason: 'unsupported_alarm_type';
	  }
	| AlarmActionStatus;

export type AlarmActionResult = AlarmActionOutcome;

export const outcomeFromAlarmActionResult = (result: AlarmActionResult): AlarmActionStatus => {
	return typeof result === 'string' ? result : result.outcome;
};
